import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import css from "./CurrentWait.css";
import Icon from 'SF/MaterialIcon';
import useStarfishAPI from "../hooks/useStarfishAPI";
import useError from "../hooks/useError";
import { urlParams } from 'utils/request';
import { formatMintuesToHoursMinutesString } from "../utils/kiosk";
import { getWord } from 'utils/tenant';

function CurrentWait(props) {

  const [{ data, success, error }, callAPI] = useStarfishAPI();
  const getCurrentWait = () => {
    const params = urlParams({
      serviceId: props.serviceId,
      studentId: props.studentId,
      isProspectiveStudent: props.isProspectiveStudent,
      email: props.email
    }, false);

    const URL = `../kiosk/checkStatusService.html?${params}`;
    callAPI(URL, {
      method: 'GET',
    });
  }
  useError(error, props.setError);
  useEffect(() => {
    getCurrentWait();
  }, [props.serviceId, props.studentId,  props.isProspectiveStudent, props.email]);

  if (!success) return null;

  const hasWaitTime = data.waitingRoomStatus && data.waitingRoomStatus.kioskMaxWaitTime > 0 && data.waitingRoomStatus.kioskQueueSize > 0;

  const waitTime = hasWaitTime ?
     formatMintuesToHoursMinutesString(data.waitingRoomStatus.kioskMaxWaitTime) : "No wait at this time."

  return (
    <div className={css["content"]}>
      {}
      <span className={css["header"]}>{getWord('dropIn', false)} Wait</span>
      <div className={css['orange-rectangle']}>

        {hasWaitTime &&
        <>
          <div className={css['in-line']}><img src="../images/starfish/wait-queue.png" aria-hidden="true" className={css['image']}/>{data.waitingRoomStatus.kioskQueueSize} in line
          </div>
          <div className={css['wait-time']}><Icon icon="access_time" aria-hidden={true} className={css['time-icon']}/> {waitTime} </div>
        </>
        }
        {!hasWaitTime &&
        <div className={css['no-wait']}><Icon icon="insert_emoticon" aria-hidden={true} className={css['time-icon']}/> {waitTime} </div>
        }
      </div>
    </div>
  );
}

CurrentWait.propTypes = {
  serviceId: PropTypes.number.isRequired,
  studentId: PropTypes.number,
  isProspectiveStudent: PropTypes.bool.isRequired,
  email: PropTypes.string,
  setError: PropTypes.func.isRequired
};

export default CurrentWait;
